import { Injectable } from '@angular/core';
import { FlatService } from './flat.service';
import {ToastService} from './toast.service';

@Injectable({
  providedIn: 'root'
})
export class ErrorService {

  constructor(private flat: FlatService,  private toastService: ToastService) {
  }

  public toastErrors(errors: any) {
    const formErrors = this.flat.flatten(errors, {safe: true});

    Object.keys(formErrors).forEach((key, index) => {
      this.toastService.showError(`${formErrors[key]}`);
    });
  }
}
